import Peer from './peer';
import localForage from "localforage";
import TransportClient from './transport-client';
import gateway from './gateway';

const buffer = {};

const config = {
  iceServers: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:188.225.9.68:3478' },
    {
      urls: 'turn:188.225.9.68:3478?transport=tcp',
      credential: 'intrahouse2019',
      username: 'intrahouse',
    },
    {
      urls: 'turn:188.225.9.68:3478?transport=udp',
      credential: 'intrahouse2019',
      username: 'intrahouse',
    },
  ]
};

function p2p(status, { key, pm }, progress) {
  status('registration check');

  const transportclient = new TransportClient();

  function signal(data) {
    console.log(data)
    status('sending settings');
    transportclient.transferdata(data);
  }

  function connect() {
    status('connection established');
    transportclient.close();

    const mode = pm ? 'pm' : 'ui';

    Promise
      .all([
        localForage.getItem(`${key}_${mode}`),
        localForage.getItem(`${key}_${mode}_bundle`)
      ])
      .then(([cacheid, data]) => {
        if (cacheid === null && data === null) {
          gateway.send({ type: 'bundle', mode, cacheid: null });
        } else {
          gateway.send({ type: 'bundle', mode, cacheid });
        }
      })
  }

  function data(msg) {
    switch (msg[0]) {
      case 48:
        gateway.message(msg.slice(1).toString(), progress);
        break;
      case 49:
        gateway.progress(msg.length - 5, progress)
        buffer[msg.slice(1, 5).toString()] = msg.slice(5).toString();
      break;
      case 50:
        gateway.progress(msg.length - 5, progress)
        const seq2 = msg.slice(1, 5).toString();
        buffer[seq2] = buffer[seq2] + msg.slice(5).toString();
        break;
      case 51:
        gateway.progress(msg.length - 5, progress)
        const seq3 = msg.slice(1, 5).toString();
        buffer[seq3] = buffer[seq3] + msg.slice(5).toString();
        gateway.message(buffer[seq3], progress);
        delete buffer[seq3];
        break;
      default:
        break;
    }
  }

  function transferdata({ transferid, data }) {
    status('answer settings');
    window.ihp2p.peer.signal(data);
  }

  function fail() {
  }

  function close() {
  }

  function open() {
    status('registered');
    status('create socket');
    window.ihp2p.peer = new Peer({ config, initiator: true })

    window.ihp2p.peer.on('signal', signal);
    window.ihp2p.peer.on('connect', connect);
    window.ihp2p.peer.on('data', data);
    window.ihp2p.peer.on('error', fail);
    window.ihp2p.peer.on('close', close);

    status('creating settings');
  }

  function error(msg) {
    status(msg, true);
  }

  transportclient.on('transferdata', transferdata);
  transportclient.on('open', open);
  transportclient.on('error', error);
  transportclient.start(key);
}

export default p2p;



// WEBPACK FOOTER //
// ./src/lib/p2p.js